import { InjectionToken } from "@angular/core";
import { SoftwareProduct } from "src/app/support/product";

export const PRODUCT_TOKEN = new InjectionToken<SoftwareProduct>(
  "product_token"
);
